/**
 * Non Post Order Details InfoCard Component
 */

// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../authContext";

//UI
import JalaliUtils from "@date-io/jalaali";
import { Controller, useForm } from "react-hook-form";

import {
  Grid,
  Button,
  Divider,
  TextField,
  FormHelperText,
  MenuItem,
  Typography,
  Dialog,
  DialogContent,
} from "@material-ui/core";

// Components
import Can from "../../components/Can";
import MapboxMap from "../../components/maps/mapboxMap";
import { Map, TileLayer, Marker } from "react-leaflet";
import DeliveryReceipt from "./deliveryReceipt/deliveryReceipt";

// Router
import { Link, useHistory } from "react-router-dom";

// Helper
import {
  translate,
  formaterPhoneNumber,
  packegeCounter,
  disablePrevDateByHour,
  convertPersianDigit2English,
  checkHourisPast,
  removeEmptyValueObject,
  numberWithCommas,
  fixNumbers,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";
import handleNotfication from "../../utils/handleNotfication";
import { isEmpty } from "lodash";
import updateLocationStatus from "client-sdk/src/orders/updateLocationStatus";

// Type
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import { Card } from "@material-ui/core";
import handleError from "../../utils/handleError";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import { UpdateOrderDeliveryCost } from "client-sdk/src/orders/orders";
import { Client } from "client-sdk/src";
import StaticMap from "../../components/maps/staticMap";
import { useCutoffHandler } from "../../utils/hook/useGetCutoffList";
import { convertDatePersianToEnglish } from "../../utils/helpers";
import getAllByDeliveryService from "client-sdk/src/orders/getAllByDeliveryService";
import moment from "moment";

// Style
import useStyles from "./useStyles";
const mapStyle = {
  position: "absolute",
  top: "134px",
  right: "40px",
  zIndex: "1000",
  minWidth: "320px",
  maxWidth: "300px",
  height: "38px",
};

const token = localStorage.getItem("token") || "";
export function InfoCard(props: any) {
  const authContext = useContext(AuthContext);
  const [editMode, setEditMode] = useState(false as boolean);
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<number>();
  const [deliveryCost, setDeliveryCost] = useState<number>();
  const [deliverInRonad, setDeliverInRonad] = useState<boolean>(false);
  const [postPaid, setPostPaid] = useState(false);
  const [couriersList, setCouriersList] = useState<any>([]);
  const [dateInDatePiker, setDateInDatePiker] = useState<any>("");
  const [deliveryTime, setDeliveryTime] = useState<any>("");
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [enableCost, setEnableCost] = useState(false);
  const [openMsg, setOpenMsg] = useState(false);
  const [locations, setLocations] = useState<any>({
    lat: 0,
    lng: 0,
  });
  const [currentLocation, setCurrentLocation] = useState<any>({
    lat: 0,
    lng: 0,
  });

  const classes = useStyles();
  const history = useHistory();

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset,
  } = useForm({
    defaultValues: {
      orderType: props.order.orderType,
      deliveryServiceId: "",
      fulfillmentTypeId: "",
      courierId: "",
      cutoffId: "",
      deliveryDate: "",
      // deliveryTime: '',
      deliveryStartTime: props.order.deliveryStartTime,
      deliveryEndTime: props.order.deliveryEndTime,
      origin: "",
      destination: "",
      customerName: "",
      customerNationalCode: "",
      customerMobileNumber: "",
      customerPhoneNumber: "",
      customerProvince: "",
      customerCity: "",
      customerZipCode: "",
      deliveryType: "",
      customerAddress: "",
    },
  });

  const [orderType, setOrderType] = useState<null | string>(
    props.order.orderType
  );
  const isFromCenter = props.order.orderType === "FROM_CENTER";
  const values = getValues();
  const fulfillmentTypeId = watch("fulfillmentTypeId");
  const courierId = watch("courierId");
  const deliveryServiceId = watch("deliveryServiceId");
  const deliveryDate = watch("deliveryDate");
  const cutoffId = watch("cutoffId");

  const formattedDateSelected = moment(deliveryDate).format("YYYY-MM-DD");
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected);

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected: dateSelected,
    forceToFind: true,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
  });

  useEffect(() => {
    if (!isEmpty(props.order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        fulfillmentWarehouseId,
        centerId,
        deliveryServiceId,
        fulfillmentTypeId,
        courierId,
        cutoffId,
        customerLat,
        customerLon,
        postPaid,
      } = props.order;
      const payload = {
        orderType,
        deliveryDate,
        deliveryServiceId,
        fulfillmentTypeId,
        courierId,
        cutoffId,
        deliveryStartTime: deliveryDate + " " + deliveryStartTime,
        deliveryEndTime: deliveryDate + " " + deliveryEndTime,
        // deliveryTime:
        //   deliveryStartTime === '11:00:00'
        //     ? '11-15'
        //     : deliveryStartTime === '16:00:00'
        //       ? '16-20'
        //       : '',
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        origin: orderType === "FROM_CENTER" ? centerId : fulfillmentWarehouseId,
        destination: orderType === "TO_CENTER" ? centerId : null,
      };
      reset(payload);
      setDeliverInRonad(props.order.deliveryLocationType === "IN_RONAD");
      setPostPaid(postPaid);
    }
  }, [props.order]);

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDeliveryCost(+e.target?.value);
  };

  const handleChangeDeliverInRonad = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDeliverInRonad(event.target.checked);
  };

  const submitOrderDeliveryCost = async () => {
    try {
      const makeRequest = new UpdateOrderDeliveryCost()
        .id(props.order.id)
        .data(orderDeliveryCost)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("هزینه ارسال با موفقیت ثبت شد", "success");
      setDeliveryCost(orderDeliveryCost);
      setOrderDeliveryCost("");
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      "deliveryDate",
      convertPersianDigit2English(date.format("YYYY-MM-DD"))
    );
    setValue("deliveryTime", "");
  };

  const handleUpdateOrders = (data: any) => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerProvince,
      customerZipCode,
      deliveryDate: deliver,
      // deliveryTime,
    } = data;

    const customerInfo = {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerPhoneNumber: props.order.customerPhoneNumber,
      customerProvince,
      customerZipCode,
      customerLat: "",
      customerLon: "",
      customerAddress,
      deliveryType: props.order.deliveryType,
      partnerId: props.order.partnerId,
      orderType: props.order.orderType,
      codPaymentCode: props.order.codPaymentCode,
      codValue: props.order.codValue,
      postPaid,
      paymentType: props.order.paymentType,
      description: props.order.description,
    };
    if (deliver.date) {
      var deliveryDate = convertPersianDigit2English(
        deliver.format("YYYY-MM-DD")
      );
    } else {
      var deliveryDate = deliver;
    }

    const payload = {
      deliveryType: props.order.deliveryType,
      deliveryDate,
      fulfillmentTypeId,
      courierId,
      deliveryServiceId,
      cutoffId,
      centerId: props.order.centerId,
      deliveryStartTime: convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(":00:00")
      ),
      deliveryEndTime: convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(":00:00")
      ),
      id: props.order.id,
      fulfillmentWarehouseId: props.order.fulfillmentWarehouseId,
      deliveryLocationType: deliverInRonad ? "IN_RONAD" : "IN_CUSTOMER_ADDRESS",
    };
    if (!isFromCenter) {
      delete payload.centerId;
    }

    const body = {
      ...removeEmptyValueObject(payload),
      ...removeEmptyValueObject(customerInfo),
    };

    body.receiptFile = "";
    body.labelFile = "";
    body.customerZipCode = fixNumbers(body.customerZipCode);

    ordersRepository
      .updateOrder({ payload: { body } })
      .then((res) => {
        handleNotfication("سفارش با موفقیت ویرایش شد", "success");
        setEditMode(false);
        history.go(0);
      })
      .catch((err) => handleError(err.response));
  };

  useEffect(() => {
    if (deliveryServiceId) {
      const handlerGetAllByDeliveryService = async () => {
        try {
          const { res, ok } = await getAllByDeliveryService(
            props.order.deliveryServiceId,
            isFromCenter
          );
          if (ok) {
            setStateFillmentTypes(res);
          }
        } catch (error) {
          handleError(error);
        }
      };
      handlerGetAllByDeliveryService();
      setLocations({
        lat: props.order.customerLat,
        lng: props.order.customerLon,
      });
    }
  }, [deliveryServiceId]);

  useEffect(() => {
    if (stateFillmentTypes.length > 0) {
      const res = stateFillmentTypes.find(
        (item: any) => item.id === fulfillmentTypeId
      );
      setCouriersList(res?.courierLogisticDTOS);
    }
  }, [fulfillmentTypeId, stateFillmentTypes]);

  useEffect(() => {
    if (couriersList?.length > 0) {
      const res = couriersList.find((item: any) => item.id === courierId);
      setEnableCost(!res?.enableCost);
    }
  }, [couriersList, courierId]);

  useEffect(() => {
    setValue("cutoffId", "");
  }, [courierId, fulfillmentTypeId]);

  useEffect(() => {
    setValue("courierId", "");
  }, [fulfillmentTypeId]);

  useEffect(() => {
    if (listCutoff.length > 0) {
      const res = listCutoff.find((item: any) => item.id === cutoffId);
      setDeliveryTime(res?.value);
    }
  }, [listCutoff, cutoffId, editMode]);

  const handleLocations = (lnglat) => {
    setCurrentLocation(lnglat);
  };

  const handlerSetLocation = async () => {
    setIsLoading(true);
    try {
      const res = await updateLocationStatus(
        currentLocation.lat,
        currentLocation.lng,
        "CONFIRMED",
        props.order.id
      );
      if (res.ok) {
        history.go(0);
        setOpenMsg(false);
        setIsLoading(false);
        props.setIsUpdateLocation(!props.isUpdateLocation);
      }
    } catch (error) {}
  };

  return (
    <Grid item lg={3} md={3} sm={12} xs={12}>
      <form onSubmit={handleSubmit(handleUpdateOrders)}>
        <Card className={classes.card}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نام شرکت:  "}</span>

                <span style={{ flex: 1 }}>{props.order?.partnerName}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پیگیری:  "}</span>

                <span style={{ flex: 1 }}>{props.order?.trackingCode} </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ارسال:  "}</span>
                <span style={{ flex: 1 }}>
                  {translate(props.order?.deliveryType)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"مبدا:  "}</span>

                <span style={{ flex: 1 }}>
                  {props.order?.fulfillmentWarehouseName
                    ? props.order?.fulfillmentWarehouseName
                    : props.order?.centerName}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد آیتم:  "}</span>
                <span style={{ flex: 1 }}>{props.order?.items?.length}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد بسته:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order?.orderPackages &&
                    props.order?.orderPackages?.reduce((acc, curr) => {
                      return acc + curr.packageCount;
                    }, 0)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع پرداخت:  "}</span>
                <span style={{ flex: 1 }}>
                  {translate(props.order.paymentType, "cod")}
                </span>
              </div>
            </Grid>

            {props.order.paymentType === "COD" && (
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"مبلغ:  "}</span>
                  <span dir="ltr">{props.order.codValue}</span>
                </div>
              </Grid>
            )}
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                {/* <span className={classes.label}>
                    {'هزینه ارسال(ریال):'}
                </span> */}
                <Can
                  role={authContext.user.role}
                  perform="orders:post-tracking-code"
                  yes={() => (
                    <div>
                      <TextField
                        id="outlined-basic"
                        disabled={enableCost}
                        value={orderDeliveryCost}
                        onChange={handleChangeDeliveryCost}
                        size={"small"}
                        variant="outlined"
                        placeholder="هزینه ارسال(ریال):"
                        // fullWidth
                      />
                      <Button
                        style={{ marginRight: "5px" }}
                        disabled={enableCost}
                        variant="contained"
                        color="secondary"
                        onClick={submitOrderDeliveryCost}
                        size={"medium"}>{`ثبت`}</Button>
                    </div>
                  )}
                  no={() => <span>{props.order?.deliveryCost}</span>}
                />
              </div>
              {deliveryCost
                ? numberWithCommas(deliveryCost)
                : numberWithCommas(props?.order?.deliveryCost)}
            </Grid>
            <Grid item xs={12} sm={12}>
              <DeliveryReceipt
                loading={isEmpty(props.order)}
                files={props.order.files}
                orderId={props.order.id}
              />
            </Grid>

            <Divider className={classes.divider} />
            {props.order.orderValue && (
              <>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{"ارزش سفارش"}</span>
                    <span style={{ flex: 1 }} dir="rtl">
                      {props.order.orderValue.toLocaleString()} ریال
                    </span>
                  </div>
                </Grid>
                <Divider className={classes.divider} />
              </>
            )}
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع پردازش:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div
                        style={{ width: "100%" }}
                        data-cy="fulfillmentTypeId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="fulfillmentTypeId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              error={
                                !!errors.fulfillmentTypeId &&
                                !!errors.fulfillmentTypeId
                              }>
                              {stateFillmentTypes?.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.fulfillmentTypeId &&
                            " بازه خدمات تحویل الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.fulfillmentTypeName}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"خدمات تحویل:"}</span>
                <span style={{ flex: 1 }}>
                  {props.order.deliveryServiceName}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ناوگان:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="courierId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="courierId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              error={!!errors.courierId && !!errors.courierId}>
                              {couriersList?.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.courierId &&
                            " بازه نوع ناوگان الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>{props.order.courierName}</span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تاریخ تحویل:  "}</span>

                {editMode ? (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <Controller
                      rules={{ required: true }}
                      name="deliveryDate"
                      control={control}
                      as={
                        <DatePicker
                          id="deliveryDate"
                          name="deliveryDate"
                          format="jYYYY/jMM/jDD"
                          okLabel="تأیید"
                          cancelLabel="لغو"
                          defaultValue={props.order.deliveryDate}
                          value={values.deliveryDate}
                          onChange={handleDeliveryDateChange}
                          error={errors.hasOwnProperty("deliveryDate")}
                          helperText={
                            errors.deliveryDate && errors.deliveryDate.message
                          }
                        />
                      }
                    />
                    <FormHelperText error focused>
                      {errors.deliveryDate && "تاریخ تحویل سفارش الزامی میباشد"}
                    </FormHelperText>
                  </MuiPickersUtilsProvider>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, "YYYY/MM/DD")
                        .locale("fa")
                        .format("jYYYY/jMM/jDD")}`}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"بازه تحویل:  "}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="cutoffId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="cutoffId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              disabled={props.order.deliveryTypeValue === ""}
                              error={!!errors.cutoffId && !!errors.cutoffId}>
                              {listCutoff.map((item) => {
                                return (
                                  <MenuItem value={item.id} id={item.id}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />

                        <FormHelperText error focused>
                          {errors?.cutoffId &&
                            " بازه تحویل سفارش الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {`${jMoment(props.order.deliveryStartTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                    {` - ${jMoment(props.order.deliveryEndTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"استان:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerProvince"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerProvince"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerProvince
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerProvince)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شهر:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerCity"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerCity"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerCity
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerCity)}
                  </span>
                )}
              </div>
            </Grid>
            <Divider className={classes.divider} />

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نام:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerName"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerName"
                        variant="standard"
                        defaultValue={props.order.customerName}
                        error={!!errors.customerName && !!errors.customerName}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>{props.order.customerName}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شماره همراه:  "}</span>
                {editMode ? (
                  <>
                    <Controller
                      name="customerMobileNumber"
                      control={control}
                      rules={{
                        required: !!orderType && orderType !== "TO_CENTER",
                        minLength: 11,
                        maxLength: 11,
                      }}
                      as={
                        <TextField
                          name="customerMobileNumber"
                          variant="standard"
                          defaultValue={formaterPhoneNumber(
                            props.order.customerMobileNumber
                          )}
                        />
                      }
                    />
                  </>
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                )}
              </div>
              <FormHelperText error focused>
                {errors?.customerMobileNumber && "شماره همراه اشتباه است"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد ملی:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerNationalCode"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      minLength: 10,
                      maxLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerNationalCode"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerNationalCode
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerNationalCode)}
                  </span>
                )}
              </div>
              <FormHelperText error focused>
                {errors?.customerNationalCode && "کد ملی اشتباه است"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"آدرس:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerAddress"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      // minLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerAddress"
                        fullWidth
                        variant="standard"
                        defaultValue={
                          props.order.customerAddress &&
                          props.order.customerAddress
                        }
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پستی:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerZipCode"
                    control={control}
                    as={
                      <TextField
                        defaultValue={props.order.customerZipCode}
                        name="customerZipCode"
                        variant="standard"
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerZipCode)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"توضیحات:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order.description && props.order.description}
                </span>
              </div>
            </Grid>
            {props.order.senderName && (
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام فرستنده:"}</span>
                  <span style={{ flex: 1 }}>{props.order.senderName}</span>
                </div>
              </Grid>
            )}
            <Divider className={classes.divider} />
            <Grid item xs={12}>
              <div>
                {editMode ? (
                  <input
                    type="submit"
                    value={"ثبت تغییرات"}
                    className={classes.submitbtn}
                  />
                ) : (
                  <Button
                    fullWidth
                    onClick={() => setEditMode(true)}
                    color="primary"
                    size="medium"
                    variant="contained">
                    تغییر سفارش
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Card>
      </form>
      {props.order.customerLat && (
        <div style={{ position: "relative" }}>
          <div style={{ height: "350px", position: "relative", zIndex: 1 }}>
            <StaticMap
              style={{
                height: "350px",
                position: "relative",
                zIndex: 1,
              }}
              zoom={14}
              center={{
                lat: props.order.customerLat,
                lon: props.order.customerLon,
              }}
              position={{
                lat: props.order.customerLat,
                lon: props.order.customerLon,
              }}
              draggable={false}
            />
          </div>

          <Button
            className={classes.btnLocationStyle}
            onClick={() => setOpenMsg(true)}
            color="primary"
            size="medium"
            variant="contained">
            ویرایش موقعیت مکانی
          </Button>
        </div>
      )}
      <Dialog
        open={openMsg}
        onClose={() => setOpenMsg(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth>
        <Typography
          style={{
            textAlign: "center",
            fontWeight: "bold",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
          variant="h5">
          موقعیت مکانی را تایید کنید.
        </Typography>
        <Typography
          onClick={() => setOpenMsg(false)}
          className={classes.closeDialogStyle}
          variant="h6">
          ✕
        </Typography>
        <Typography style={{ textAlign: "center" }} variant="h6">
          آدرس:{props.order.customerAddress}
        </Typography>
        <DialogContent>
          <MapboxMap
            loadingSubmitMap={isLoading}
            style={mapStyle}
            positionMarker={locations}
            setLatlng={handleLocations}
          />
          <div style={{ margin: "25px 0", textAlign: "center" }}>
            <Button
              disabled={isLoading}
              variant="contained"
              color="primary"
              onClick={handlerSetLocation}>
              {`تایید موقعیت مکانی`}
            </Button>
            <Button
              style={{ marginRight: "16px" }}
              variant="outlined"
              color="primary"
              onClick={() => setOpenMsg(false)}>
              {`انصراف`}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Grid>
  );
}

export default InfoCard;
